const mountTarget = document.getElementById('app')
const shouldMountVueApp = document.body?.dataset.vueApp === 'enabled' && mountTarget

if (shouldMountVueApp) {
  window.NomadPageTransitions?.init({ mode: 'attribute' })

  Promise.all([
    import('vue'),
    import('./App.vue'),
    import('./router'),
  ]).then(([vueModule, appModule, routerModule]) => {
    const { createApp } = vueModule
    const App = appModule.default
    const router = routerModule.default

    createApp(App).use(router).mount('#app')
  })
}
